import React from "react";
import { Box, Typography, Grid, IconButton, Button } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const Contactanos = ({ handleClose, open }) => {
  return (
    <Box
      sx={{
        width: { xs: "90%", sm: "600px" },
        height: "auto",
        bgcolor: "background.paper",
        boxShadow: 24,
        p: 4,
        mx: "auto",
        my: "5vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        fontSize: "1.2rem",
      }}
    >
      <Typography variant="h4" gutterBottom textAlign="center">
        CONTACTANOS
      </Typography>

      <Grid container spacing={2} alignItems="center">
        <Grid item>
          <IconButton>
            <EmailIcon />
          </IconButton>
        </Grid>
        <Grid item xs={12} sm={10}>
          <Typography
            textAlign={{ xs: "center", sm: "left" }}
            sx={{ wordBreak: "break-word" }}
          >
            proteccionalusuario@conatel.gob.hn
          </Typography>
        </Grid>
      </Grid>

      <Grid container spacing={2} alignItems="center">
        <Grid item>
          <IconButton>
            <PhoneIcon />
          </IconButton>
        </Grid>
        <Grid item>
          <Typography>
            9999-3052 / 3399-4679 / 2232-9600 <br />
            Línea gratuita 185
          </Typography>
        </Grid>
      </Grid>

      <Grid container spacing={2} alignItems="center">
        <Grid item>
          <IconButton>
            <LocationOnIcon />
          </IconButton>
        </Grid>
        <Grid item>
          <Typography textAlign="center">
            Edificio CONATEL, 6 Ave. S.O. Colonia Modelo, Comayagüela, M.D.C.{" "}
            <br />
            Honduras Apdo. 15012.
          </Typography>
        </Grid>
      </Grid>

      <Typography variant="body1" gutterBottom textAlign="center">
        Horario de Atención: 8:00 a.m. a 4:00 p.m.
      </Typography>

      <Box display="flex" justifyContent="center" mt={2}>
        <Button variant="contained" color="primary" onClick={handleClose}>
          CERRAR
        </Button>
      </Box>
    </Box>
  );
};

export default Contactanos;
